var app = angular.module('leonardo');

var AccountUserService = function(BaseRestService, $q, AuthService, RestangularProvider, CacheService) {
  var service = new BaseRestService('account-users', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('account-users', false, function(accountUser) {
      accountUser.addRestangularMethod('deleteReportTo', 'post', 'delete');
      accountUser.addRestangularMethod('unDelete', 'post', 'undelete');
      return accountUser;
    });
  });

  service.getReports = function(params) {
    return RestangularProvider.all('account-users').customGET('report', params);
  };

  service.getAvailableToAssign = function(params) {
    return RestangularProvider.all('account-users').customGET('available-users-to-assign', params);
  };

  service.getUsersReportTo = function(account_user, params) {
    return RestangularProvider.one('account-users', account_user).customGET('available-report-to', params);
  };

  service.acceptAllAudits = function(params) {
    return RestangularProvider.all('account-users').customPOST(params, 'templates-audit/accept');
  };

  service.rejectAllAudits = function(params) {
    return RestangularProvider.all('account-users').customPOST(params, 'templates-audit/reject');
  };

  service.exportAccountUsers = function (params) {
    return RestangularProvider.all('account-users').customGET('export-users', params);
  };

  service.one = function (id) {
    return RestangularProvider.one('account-users', id);
  };

  service.get = function(id, params) {
    var defer = $q.defer();
    RestangularProvider.one('account-users', id).customGET('', params).then(function(data){
      data.deleteReportTo = function(params) {
        return RestangularProvider.one('account-users', this.id).customPOST(params, 'delete');
      };
      data.unDelete = function() {
        return RestangularProvider.one('account-users', this.id).customPOST({}, 'undelete');
      };
      data.patch = function(params) {
        return RestangularProvider.one('account-users', this.id).patch(params);
      };
      data.remove = function(params) {
        return RestangularProvider.one('account-users', this.id).remove(params);
      };
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getlist = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('account-users').customGET('', params).then(function(data){
      angular.forEach(data.results, function(account_user){
        account_user.deleteReportTo = function() {
          return RestangularProvider.one('account-users', this.id).customPOST({}, 'delete');
        };
        account_user.unDelete = function() {
          return RestangularProvider.one('account-users', this.id).customPOST({}, 'undelete');
        };
        account_user.patch = function(params) {
          return RestangularProvider.one('account-users', this.id).patch(params);
        };
        account_user.remove = function(params) {
          return RestangularProvider.one('account-users', this.id).remove(params);
        };
      });
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getCurrentPermissions = function(params) {
    return RestangularProvider.one('users', this.currentAccountUser.user.id).customGET('permissions', params);
  };

  service.TYPE_OWNER = '0';
  service.TYPE_REGIONAL = '1';
  service.TYPE_PROPERTY = '2';
  service.TYPE_MANAGER = '3';
  service.TYPE_VENDOR = '4';
  service.TYPE_ADMIN = '5';

  service.TYPE_OPTIONS = [
    service.TYPE_OWNER,
    // service.TYPE_REGIONAL,
    service.TYPE_PROPERTY,
    service.TYPE_MANAGER,
    service.TYPE_VENDOR
  ];

  service.ARRAY_TYPE_OPTIONS = [
    {id: service.TYPE_OWNER, name: 'Owner'},
    // {id: service.TYPE_REGIONAL, name: 'Regional Manager'},
    {id: service.TYPE_PROPERTY, name: 'Manager'},
    {id: service.TYPE_MANAGER, name: 'Site Staff'}
  ];

  service.GENDER_MALE = '0';
  service.GENDER_FEMALE = '1';

  service.GENDER_OPTIONS = [
    {id: service.GENDER_MALE, name: 'Male'},
    {id: service.GENDER_FEMALE, name: 'Female'}
  ];

  service.STATUS_ACTIVE = '1';
  service.STATUS_DEACTIVATED = '0';

  service.STATUS_OPTIONS = [
    {id: service.STATUS_ACTIVE, name: 'Active Users'},
    {id: service.STATUS_DEACTIVATED, name: 'Disabled Users'}
  ];

  service.currentAccountUsers = [];
  service.currentAccountUser = null;

  service.getAccountUser = function (account) {
    var accountId = account && account.id ? account.id : account;
    var result = service.currentAccountUser;
    angular.forEach(service.currentAccountUsers, function (account_user) {
      var UserAccountId = account_user.account && account_user.account.id ? account_user.account.id : account_user.account;
      if (UserAccountId == accountId) {
        result = account_user;
      }
    });
    return result;
  };

  service.updateVisibleRoles = function (role, remove) {
    var index = -1;
    var index_role = -1;
    angular.forEach(service.currentAccountUsers, function (value, key) {
      if (role.account === value.account) {
        index = key;
      }
    });
    if (index >= 0 && service.currentAccountUsers[index].role) {
      index_role = -1;
      angular.forEach(service.currentAccountUsers[index].role.visible_roles, function (value, key) {
        if (role.id === value.id) {
          index_role = key;
        }
      });
      if (index_role >= 0) {
        if (remove) {
          service.currentAccountUsers[index].role.visible_roles.splice(index_role, 1);
        }
        else {
          service.currentAccountUsers[index].role.visible_roles[index_role] = role;
        }
      }
      else {
        service.currentAccountUsers[index].role.visible_roles.push(role);
      }
      index_role = -1;
      angular.forEach(service.currentAccountUsers[index].role.editable_roles, function (value, key) {
        if (role.id === value.id) {
          index_role = key;
        }
      });
      if (index_role >= 0) {
        if (remove) {
          service.currentAccountUsers[index].role.editable_roles.splice(index_role, 1);
        }
        else {
          service.currentAccountUsers[index].role.editable_roles[index_role] = role;
        }
      }
      else {
        service.currentAccountUsers[index].role.editable_roles.push(role);
      }
    }
    service.currentAccountUser = service.getCurrentAccountUser(service.currentAccountUsers);
  };

  service.getCurrentAccountUser = function (list) {
    var account_user = null;
    angular.forEach(list, function (element) {
      if (!element.managed_by) {
        account_user = element;
      }
    });
    return account_user;
  };

  service.getCurrent = function(isExclude) {
    var token = AuthService.getDecodedToken();
    var defer = $q.defer();
    let params = { user: token.user_id, with_externals: true };
    if (isExclude) {
      params.exclude = 'portfolios,properties,categories';
    }
    var cachedData = CacheService.get('currentAccount');
    if (cachedData !== null) {
      service.currentAccountUsers = cachedData.list;
      service.currentAccountUser = cachedData.current;
      service.getCurrentPermissions().then(function (data) {
        service.currentAccountUser.permissions = data.results ? data.results : data;
      });
      defer.resolve({current: service.currentAccountUser, list: service.currentAccountUsers});
      return defer.promise;
    }
    else {
      service.getlist(params).then(function(list) {
        service.currentAccountUsers = list.results ? list.results: list;
        service.currentAccountUser = service.getCurrentAccountUser(service.currentAccountUsers);
        service.getCurrentPermissions().then(function (data) {
          service.currentAccountUser.permissions = data.results ? data.results : data;
        });
        CacheService.set('currentAccount', {current: service.currentAccountUser, list: service.currentAccountUsers});
        defer.resolve({current: service.currentAccountUser, list: service.currentAccountUsers});
      }, function(){
        defer.resolve({});
      });
    }
    return defer.promise;
  };

  return service;
};

var AccountUserActivityService = function(BaseRestService, RestangularProvider) {

  var service = new BaseRestService('account-users-activity', function(RestangularConfigurer) {
    // This is intentional do_something blank function
  });

  service.getReports = function(params) {
    return RestangularProvider.all('account-users-activity').customGET('report', params);
  };

  service.getReportsOnDemand = function(params) {
    return RestangularProvider.all('account-users-activity').customGET('on-demand-instruction/access-report', params);
  };

  return service;
};

app.factory('AccountUserService', ['BaseRestService', '$q', 'AuthService', 'Restangular', 'CacheService', AccountUserService]);
app.factory('AccountUserActivityService', ['BaseRestService', 'Restangular', AccountUserActivityService]);
